export default __webpack_public_path__ + "static/media/stands_ind_-signify.af09a6f4.jpg";